import type { SVGProps } from 'react';

export type ReferenceIconName =
  | 'activity' | 'api' | 'archive' | 'arrow' | 'audio' | 'bell' | 'building'
  | 'calendar' | 'check' | 'check-circle' | 'chevron' | 'close' | 'database'
  | 'download' | 'edit' | 'error-circle' | 'expand' | 'eye' | 'file' | 'filter'
  | 'folder' | 'grid' | 'help' | 'image' | 'info-circle' | 'lock' | 'logout'
  | 'menu' | 'more' | 'plug' | 'publish' | 'refresh' | 'search' | 'settings'
  | 'shield' | 'spark' | 'star' | 'table' | 'trash' | 'upload' | 'user'
  | 'users' | 'video';

export function ReferenceIcon({ name, ...props }: SVGProps<SVGSVGElement> & { name: ReferenceIconName }) {
  return <svg aria-hidden="true" focusable="false" {...props}><use href={`/reference-icons.svg#i-${name}`} /></svg>;
}
